export const animationDuration = 250;
